import { Injectable } from "@angular/core";
import * as Bowser from "bowser";

@Injectable({
  providedIn: "root",
})
export class BrowserCheckService {
  constructor() {}

  isBrowserOutdated(): boolean {
    const browser = Bowser.getParser(window.navigator.userAgent);

    const result = browser.satisfies({
      chrome: ">=100",
      firefox: ">=100",
      safari: ">=14",
      edge: ">=100",
      ios: ">=14",
      android: ">=100",
    });

    return result !== true;
  }

  getBrowserNameAndVersion(): string {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const info = browser.getBrowser();
    return `${info.name} ${info.version}`;
  }
}
